import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { Observable, ReplaySubject } from 'rxjs';
import { map, take, takeWhile, tap } from 'rxjs/operators';
import { IStatusMessage } from '../../../shared';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { getUserInfo, IUserInfo } from '../../../user-info';
import * as fromStore from '../../store';
@Component({
    selector: 'ef-indirect-rate-structure-container',
    templateUrl: './indirect-rate-structure-container.component.html',
    styleUrls: ['./indirect-rate-structure-container.component.scss'],
    standalone: false
})
export class IndirectRateStructureContainerComponent
    implements OnInit, OnDestroy
{
    rateStructures$: Observable<fromStore.Structure.IndirectRateStructure[]>;
    rateTypes$: Observable<SelectItem[]>;
    userInfo$: Observable<IUserInfo>;
    // SaveItemSubject = new ReplaySubject<fromStore.IndirectRateStructure[]>(1);
    private active = true;
    @Input() selectedError: IStatusMessage;
    @Input() FiscalYearEndDate: Date;
    @Input() showAdjustments: boolean;
    @Input() disabled: boolean;
    @Output() Save = new ReplaySubject<
        fromStore.Structure.IndirectRateStructure[]
    >(1);
    @Output() ShowRateReview = new EventEmitter();
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    private addTemplate: fromStore.Structure.IndirectRateStructure = {
        id: 'add',
        Adjusteddate: null,
        Adjustedrate: null,
        Calcshortdesc: '',
        Calctype: '',
        Costcenterid: -1,
        FYadjusted: null,
        FYenddate: null,
        Maintdate: null,
        Maintdate_pending: null,
        Modifiedby: null,
        Ratepercent_pending: null,
        Ratepercent: null,
        Row_Version: '0x0000000000000000',
        Status: {
            Message: '',
            MsgEntityID: null,
            MsgProcessID: null,
            StatusCode: 0
        }
    };
    constructor(
        private store: Store<fromStore.Structure.State>,
        private dispatcher: ActionsSubject,
        private log: LoggingService
    ) {}

    ngOnInit() {
        this.setupSubscriptions();
    }
    ngOnDestroy() {
        this.active = false;
    }
    setupSubscriptions() {
        this.rateStructures$ = this.store.pipe(
            select(fromStore.Structure.selectAll),
            map(x => clone(x)),
            map(items => items.filter(x => x.id !== 'add')),
            map(items => [{ ...this.addTemplate }, ...items])
        );
        this.rateTypes$ = this.store.pipe(
            select(fromStore.Structure.selectIndirectRateTypes),
            map(rates =>
                rates.map(x => ({ label: x.CalcDesc, value: x.CalcType }))
            )
        );
        this.userInfo$ = this.store.pipe(select(getUserInfo));
        this.store
            .pipe(
                select(fromStore.Structure.selectAll),
                takeWhile(() => this.active),
                tap(items =>
                    this.log.verbose({
                        type: 'IndirectRateStructureContainerComponent:rateStructures$',
                        items
                    })
                )
            )
            .subscribe(items => {
                this.ShowRateReview.next(
                    items.some(
                        item =>
                            item.FYadjusted &&
                            item.FYadjusted.toLocaleLowerCase().includes(
                                'pending'
                            )
                    )
                );
            });
    }

    onSaveItem(items: fromStore.Structure.IndirectRateStructure[]) {
        this.log.verbose({
            type: 'IndirectRateStructureContainerComponent:onSaveItem',
            items
        });
        this.dispatcher
            .pipe(
                ofType(fromStore.Structure.upsertIndirectRateStructures),
                take(1)
                // , map(resp => resp.payload.Items[0])
            )
            .subscribe(resp => {
                this.log.verbose({
                    type: 'IndirectRateStructureContainerComponent:upsertIndirectRateStructures',
                    resp
                });
                this.Save.next(items);
            });
        this.store.dispatch(
            fromStore.Structure.putIndirectRateStructures({
                indirectRateStructures: items
            })
        );
    }
    onDeleteItem(items: fromStore.Structure.IndirectRateStructure[]) {
        this.log.verbose({
            type: 'IndirectRateStructureContainerComponent:onDeleteItem',
            items
        });
        this.Save.next(items);
        this.store.dispatch(
            fromStore.Structure.removeIndirectRateStructures({
                indirectRateStructures: items
            })
        );
    }
}
